import { ApiEndpoints } from "./apiEndpoints";
import { fetchData, setHeaderOptions } from "./apiHelpers";
import { CreateVitalRow, UpdateVitalRow, VitalRow } from "./vital.type";

export const getVital = async (vitalId: string): Promise<VitalRow> => {
  const slug = ApiEndpoints.vital + `/${vitalId}`;

  const options = await setHeaderOptions({ method: "GET" });

  return fetchData<VitalRow>(slug, options);
};

export const getVitals = async (userId?: string): Promise<VitalRow[]> => {
  const slug = ApiEndpoints.vital + (userId ? `/user/${userId}` : "");

  const options = await setHeaderOptions({ method: "GET" });

  return fetchData<VitalRow[]>(slug, options);
};

export const updateVital = async (
  vital: UpdateVitalRow,
  patientUserId?: string
): Promise<VitalRow> => {
  let slug = ApiEndpoints.vital + "/" + vital.id;

  if (patientUserId) {
    slug += `?patient_user_id=${patientUserId}`;
  }

  const options = await setHeaderOptions({ method: "PUT", body: vital });

  return fetchData<VitalRow>(slug, options);
};

export const createVital = async (
  vital: CreateVitalRow,
  patientUserId?: string
): Promise<VitalRow> => {
  let slug = ApiEndpoints.vital + "/";

  if (patientUserId) {
    slug += `?patient_user_id=${patientUserId}`;
  }

  const options = await setHeaderOptions({ method: "POST", body: vital });

  return fetchData<VitalRow>(slug, options);
};
